import React, { PropsWithChildren } from "react";
import { genUUID } from "../lib/genUUID";

interface MessageData {
  className?: string;
  message: string;
  id?: any;
}

interface NotificationContextProps {
  messages: MessageData[];
  removeMessage: (id: string) => void;
  setMessage: (data: MessageData) => void;
}

export const NotificationContext =
  React.createContext<NotificationContextProps>({
    messages: [],
    removeMessage: () => {},
    setMessage: (value: any) => {},
  });

const Provider = NotificationContext.Provider;
export function NotificationProvider({ children }: PropsWithChildren) {
  const [alerts, setAlerts] = React.useState<MessageData[]>([]);

  const setMessage = (data: MessageData, duration?: number) => {
    console.log("message notification data ");
    if (!data.id) {
      data.id = genUUID();
    }
    setAlerts((current) => [...current, data]);

    setTimeout(() => {
      removeMessage(data.id);
    }, duration ?? 3000);
  };

  const removeMessage = (id: any) => {
    setAlerts((current) => current.filter((msg) => msg.id !== id));
  };
  return (
    <Provider value={{ messages: alerts, setMessage, removeMessage }}>
      {children}
    </Provider>
  );
}

export default NotificationProvider;
